import { Schedule } from "../../types/Schedule";

export enum ScheduleActionTypes {
  API_RESPONSE_SUCCESS = '@@schedules/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR = '@@schedules/API_RESPONSE_ERROR',
  UPDATE_SCHEDULE = '@@schedules/UPDATE_SCHEDULE',
  GET_SCHEDULES = '@@schedules/GET_SCHEDULES',
  OPEN_MODAL = '@@schedules/OPEN_MODAL',
  CLOSE_MODAL = '@@schedules/CLOSE_MODAL',
}


export interface ScheduleActionType {
  type:
    | ScheduleActionTypes.API_RESPONSE_SUCCESS
    | ScheduleActionTypes.API_RESPONSE_ERROR
    | ScheduleActionTypes.UPDATE_SCHEDULE
    | ScheduleActionTypes.GET_SCHEDULES
    | ScheduleActionTypes.OPEN_MODAL
    | ScheduleActionTypes.CLOSE_MODAL  
 payload?: {
     actionType?: string;
     data?: Schedule | Schedule[] | {};
     error?: string;
   };
}

export interface ScheduleState {
  loading: boolean;
  schedules: ScheduleData[];
  error: string;
  modal: boolean;
}
export interface ScheduleData {
  id: number;
  weekNumber: number;
  userId: number;
  startTime: string;
  endTime: string;
  onVacation: boolean;
}


export interface State {
  schedule?: ScheduleData | {};
  loading?: boolean;
  value?: boolean;
  modal:boolean;
}

export interface ScheduleData {
  id: number,
  weekNumber: number,
  userId: number,
  startTime: string,
  endTime: string,
  onVacation: boolean,
}
// common success
export const scheduleApiResponseSuccess = (
  actionType: string,
  data: ScheduleData | {}
): ScheduleActionType => ({
  type: ScheduleActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const scheduleApiResponseError = (
  actionType: string,
  error: string
): ScheduleActionType => ({
  type: ScheduleActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});
